/* Shared quantity ladder. Rates are a local concept, never a Shopify discount. */
(() => {
  if (globalThis.DasheaTiers) return;
  const tiers = Object.freeze([{count:8,rate:10},{count:12,rate:15},{count:16,rate:20},{count:20,rate:25}]);
  const rate = (count, ladder = tiers) => ladder.reduce((r,t) => count >= t.count ? t.rate : r, 0);
  function position(count, ladder = tiers) {
    const next = ladder.findIndex(t => count < t.count);
    const center = i => i < 0 ? [0,0] : [(i+.5)*100/ladder.length,(i+.5)/ladder.length-.5];
    if (next < 0) return center(ladder.length-1);
    const previous = next ? ladder[next-1].count : 0;
    const fraction = Math.max(0,(count-previous)/(ladder[next].count-previous));
    const a = center(next-1), b = center(next);
    return a.map((v,i) => v+(b[i]-v)*fraction);
  }
  function paint(meter, count, ladder = tiers) {
    if (!meter) return;
    const [percent,gap] = position(count,ladder);
    meter.style.setProperty('--dh-tier-fill',`calc(${percent}% + var(--dh-tier-gap) * ${gap})`);
    meter.setAttribute('aria-valuenow',String(Math.min(ladder.at(-1).count,count)));
    meter.setAttribute('aria-valuetext',`${count} masek, množstevní sleva ${rate(count,ladder)} %`);
    meter.querySelectorAll('i').forEach((point,i) => point.toggleAttribute('data-reached',count>=ladder[i].count));
  }
  globalThis.DasheaTiers = Object.freeze({tiers,rate,position,paint});
})();
